var App = App || {};


App.Base = (function () {
    'use strict';

    const state = {
        modalUrls: [],
        observerMap: new WeakMap()
    };

    // Loads modal URLs and initializes page-level JS behaviors; called on DOMContentLoaded.
    const pageLoad = async () => {
        try {
            state.modalUrls = await App.Modals.fetchModalUrls();
        } catch (error) {
            console.error("Failed to fetch modal URLs:", error);
            state.modalUrls = [];
        }
        observeAndInitializeJs(document);
        handleAnchorClick(document);
        App.Helpers.responsiveTables(document);
        App.NoWrapChevrons.initialize(document);
        App.Bootstrap.activateElement(document, location.hash);
    };


    // Initializes JS for elements with [data-init-js] and observes for new ones dynamically.
    const observeAndInitializeJs = (context = document.body) => {

        // Initialize all current [data-init-js] elements
        const initializations = context.querySelectorAll('[data-init-js]');
        initializations.forEach(initialization => {
            const initializationKey = initialization.dataset.initJs;
            const fn = App.Initialization[initializationKey]?.initialize;
            if (typeof fn !== "function") {
                console.warn("No js initialization handler for:", initializationKey);
                return;
            }
            fn(initialization);
            initialization.removeAttribute("data-init-js");
        });

        // Only attach one observer per context
        if (state.observerMap.has(context)) {
            return;
        }

        // Set up a MutationObserver to watch for new elements needing JS initialization
        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach(mutation => {
                for (const node of mutation.addedNodes) {

                    const isElement = node.nodeType === 1;
                    const isDirectInitJs = isElement && node.hasAttribute?.('data-init-js');
                    const hasInitJsDescendant = isElement && node.querySelector?.('[data-init-js]');
                    const shouldInitialize = isDirectInitJs || hasInitJsDescendant;

                    if (shouldInitialize) {
                        const newInitializations = context.querySelectorAll('[data-init-js]');
                        newInitializations.forEach(initialization => {
                            const initializationKey = initialization.dataset.initJs;
                            const fn = App.Initialization[initializationKey]?.initialize;
                            if (typeof fn === "function") {
                                fn(initialization);
                                initialization.removeAttribute("data-init-js");
                                return;
                            }
                            console.warn("No js initialization handler for:", initializationKey);
                        });
                        break;
                    }
                }
            });
        });

        observer.observe(context, { childList: true, subtree: true });
        state.observerMap.set(context, observer);
    };

    // Anchor click handling by context to delegate Bootstrap elements, modals, speedbumps
    const handleAnchorClick = (context) => {
        if (!context || context._handleAnchorClickAttached) return;
        context._handleAnchorClickAttached = true;

        // Define the ordered pipeline of click handlers
        const handlers = [
            (ctx, a) => {
                const href = a.getAttribute("href") || "";
                App.Bootstrap.activateElement(ctx, href)
            },
            (ctx, a) => App.Modals.openModalFromAnchor(state.modalUrls, a),
            (ctx, a) => App.SpeedBump.initialize(a),
            (ctx, a) => App.ClickToCopy.CopyToClipboardExecute(a),
        ];

        // Handler for click events on anchors
        const handleClick = (e) => {
            const anchor = e.target.closest("a");
            if (!anchor || !context.contains(anchor)) return;

            // Run each handler until one returns true
            const handled = handlers.some(fn => fn(context, anchor) === true);

            if (handled) {
                e.preventDefault();
                e.stopPropagation();
            }
        };

        // Attach listener to the container
        context.addEventListener("click", handleClick);
    };


    return {
        pageLoad,
        handleAnchorClick
    };

})();

document.addEventListener("DOMContentLoaded", function () {
    App.Base.pageLoad();
});